<template>
  <v-container fluid class="primary">
    <v-container>
        <v-row>
            <v-col class="d-flex justify-end" cols="12" justify="center">
                

    <v-dialog v-model="showModal"
              min-width="fit-content"
              max-width="800px"
              :adaptive="adaptive"
              @keydown.esc="showModal = false">
      <template v-slot:activator="{ on }">
                <v-btn x-large
                raised
                class="fifth primary--text"
                v-on="on"
                  >
                    Contact Me 
                    <v-icon class="pl-4">contact_mail</v-icon>
                </v-btn>      
    </template>
    
      <v-card class="pa-8 pb-4 primary">
         <v-row >
        <v-col cols="12" v-if="!submitted" >
            <p class="fifth--text display-2">Contact Me</p><br>
            <!-- <p class="headline font-weight-light">If you have any <span class="font-weight-regular">comments or thoughts to share</span>,
                I am interested in hearing what you have to say. Please enter your name, email, and message that you
                would like to send and I will respond as soon as I can. Thanks!</p> -->
                <div>
                <v-form ref="form" class="">
                    <v-text-field
                    id="name"
                    v-model="contact.name"
                    label="Your Name"
                    outlined
                    required
                    color="fifth"
                    v-validate="'required|max:30'"
                    data-vv-name="name"
                    :error-messages="errors.collect('name')"
                    ></v-text-field>

                    <v-text-field
                    id="email"
                    v-model="contact.email"
                    label="Your Email"
                    outlined
                    required
                    color="fifth"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    :error-messages="errors.collect('email')"
                    ></v-text-field>

                    <v-textarea
                    id="msg"
                    v-model="contact.message"
                    label="Message"
                    outlined
                    required
                    color="fifth"
                    :counter="1000"
                    v-validate="'required|max:1000'"
                    data-vv-name="message"
                    :error-messages="errors.collect('message')"
                    ></v-textarea>

                    <div class="d-flex justify-space-between mt-4">

                    <v-btn 
                    depressed 
                    x-large
                    class="fifth primary--text ma-2 ml-0"
                    width="24%"
                    @click="showModal = false & SendMsgAgain()"
                    >
                    close
                    </v-btn>
                    
                        <v-progress-circular class="ml-4" color="grey" indeterminate v-if="valid"/>
                        <v-btn 
                        depressed 
                        x-large
                        
                        id="submitBtn"
                        class="green darken-2 primary--text ma-2 ml-0"
                        width="24%"
                        @click="onSubmit()"
                        >
                        Send <v-icon class="pl-2">send</v-icon>
                        </v-btn>
                    </div>

                </v-form>
                </div>
        </v-col>
        <v-col v-else-if="submitted">
            <!-- <v-alert type="success" max-width="600px">Email has been successfully sent</v-alert><br> -->
            <p class="display-1">Thank you</p>
                <p class="headline font-weight-light">I really appreciate you taking the time and writing me a message. I will respond to you shortly via email.</p>
                <!-- <v-alert type="error">Updated: Feb 3, 2020. This form is currently being made. Please email me directly at:  <u>alexandre.rogov@gmail.com</u> </v-alert> -->
                <h3 class="title"><u>Message sent:</u></h3>

                <div class="mt-2">
                <span class="subtitle font-weight-bold">Date:</span>
                <span class="subtitle ml-4 mb-2">{{ contact.date }}</span>
                </div>

                <div class="mt-2">
                <span class="subtitle font-weight-bold">From: </span>
                <span class="subtitle ml-4 mb-2">{{ contact.name }}</span>
                </div>

                <div class="mt-2">
                <span class="subtitle font-weight-bold">Email: </span>
                <span class="subtitle ml-4 mb-2">{{ contact.email }}</span>
                </div>

                <div class="mt-2">
                <span class="subtitle font-weight-bold">Message: </span>
                <div class="subtitle ml-4 mb-2 mt-3">{{ contact.message }}</div>
                </div>

                <div class="d-flex justify-end">
                    <v-btn width="24%" depressed x-large class="fifth primary--text ma-2 mt-12" @click="showModal = false & SendMsgAgain()">Close</v-btn>
                </div>
        </v-col>
        </v-row>
      </v-card>
    </v-dialog>




            </v-col>
        </v-row>

    </v-container>
  </v-container>
</template>

<script>
const axios = require("axios").default;
export default {
  name: "Contact-Me",
  
  data() {
    return {
    
      contact: {
        date: '',
        name: '',
        email: '',
        message: ''
      },
      showModal: false,
      submitted: false,
      valid: false,
      loading: false,
      
    };
  }, 
  methods: {
  onSubmit() {
      this.$validator.validate().then(valid => {
        this.valid = true;
        if(valid){
          this.sendEmail() // awaits for promise and changes 'this.submitted' if api went through
        } else
        this.valid = false;
      })
    },
    async sendEmail() {
        console.log('Sending API request');
        try {
          const result = await axios.post('https://fathomless-falls-63366.herokuapp.com/email', {
            name: this.contact.name,
            email: this.contact.email,
            message: this.contact.message,
        });
          this.submitted = true;
          console.log('result: '+ result);
          this.contact.date = new Date().toLocaleString();
          this.$notify({
            group: 'success',
            type: 'success',
            title: 'Success',
            text: 'Email was sent',  
            duration: '4000'
        })
        } catch (error) {
          this.submitted = false;
          console.log(error);
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Oops!',
            text: 'Error in connecting to server. Please try again later',
            duration: '4000'
          })
        }
        this.valid = false;
      },
      SendMsgAgain() {
      this.submitted=false;
      this.valid = false;
      this.contact.name = ''
      this.contact.email = ''
      this.contact.message = ''
      this.errors.clear();
      },
  },
};
</script>

<style>

</style>